import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  landscape: {},
  portrait: {},
  donations: {
    flexGrow: 1,
    padding: theme.spacing(2.5),
    color: 'white',
    minHeight: '100%',
    background:
      'linear-gradient(130deg, rgba(235,46,107,1) 0%, rgba(26,163,255,1) 100%)',
    fallbacks: {
      background: 'rgb(235,46,107)'
    }
  },
  donationsAutoSizer: {
    width: ['100%', '!important'],
    flexGrow: 1
  },
  donationsList: {
    paddingRight: 20
  },
  noDonationsTypography: {
    color: 'white',
    zIndex: 1,
    position: 'relative',
    fontSize: '2rem',
    textAlign: 'center',
    marginBottom: theme.spacing(3),
    textTransform: 'uppercase'
  },
  donateNowText: {
    fontSize: 40,
    color: 'white',
    lineHeight: '55px',
    textAlign: 'center'
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/DonationsList/styles.js